import { OrderStatus } from "@goodfill/domain-properties";

const STATUSES_AVAILABLE_MODIFY = [
  OrderStatus.Open,
  OrderStatus.FillSubmittedToBroker,
  OrderStatus.FillAcknowledgedByBroker,
];

export function canModifyOrder(orderTicket: { status: OrderStatus; isImmediate: boolean }) {
  return STATUSES_AVAILABLE_MODIFY.includes(orderTicket.status) && !orderTicket.isImmediate;
}
